import { Button } from '@nextui-org/react'
import { formatDate } from '@scripts/frontend/libs/utils/format-date'
import { formatPrice } from '@scripts/frontend/libs/utils/format-price'
import { Link } from 'react-router-dom'

import type { Order } from '../libs/type'

import OrderProductItem from './OrderProductItem'
import OrderStatus from './OrderStatus'

export interface OrderItemProps {
  order: Order
}

export function OrderItem({ order }: Readonly<OrderItemProps>) {
  const { createdDate, orderId, orderItems, status, total } = order

  return (
    <div className="border">
      <div className="flex justify-between gap-4 p-6">
        <div className="grid space-y-6 md:flex md:space-x-16 md:space-y-0">
          <div>
            <h4 className="font-medium">Order number</h4>
            <Link to={`/my-account/view-order/${orderId}`}> #{orderId}</Link>
          </div>
          <div>
            <h4 className="font-medium">Date</h4>
            <span>{formatDate(new Date(createdDate))}</span>
          </div>
          <div>
            <h4 className="font-medium">Total</h4>
            <span>{formatPrice(total)}</span>
          </div>
        </div>
        <div>
          <OrderStatus status={status} />
        </div>
      </div>
      <div className="border-y">
        <div className="grid divide-y divide-gray-200">
          <section>
            {orderItems?.map((item, index) => (
              <OrderProductItem key={index} {...item} />
            ))}
          </section>
        </div>
      </div>
      <div className="flex justify-between gap-4 p-6">
        <div className="flex space-x-16"></div>
        <div className="space-x-2">
          <Button
            as={Link}
            to={`/my-account/view-order/${orderId}`}
            variant="bordered"
          >
            View
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OrderItem
